import React from 'react'
import {Link} from 'react-router-dom'
import logo from '../img/logo.png'
import './Component.css'

function Head(props){
    return(
        <div id="navbar">
            {/*<img src={logo}></img>*/}
            <Link to='/'>
                <h1>Vivian Chan</h1>
            </Link>
            
        </div>
    )
}

export default Head;